// extracted by mini-css-extract-plugin
export default {"container":"vo-z"};